<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" title="开通支付" width="800px"
    @close="cancelTimer">
    <div>
      <div>
        <table class="table table-bordered">
          <tbody>
            <tr>
              <th>订单编号：</th>
              <td colspan="2">
                <strong>{{ formData.orderNo }}</strong>
              </td>
            </tr>
            <tr>
              <th>订单金额：</th>
              <td colspan="2" style="color: red">￥{{ formData.amount }}元</td>
            </tr>
            <tr v-if="formData.product">
              <th>开通内容：</th>
              <td colspan="2">
                {{ formData.product }}
              </td>
            </tr>
            <tr v-if="formData.describe">
              <th>费用描述：</th>
              <td colspan="2">
                {{ formData.describe }}
              </td>
            </tr>
            <!-- <tr>
              <th>创建时间：</th>
              <td>
                {{ formatTime(formData.createTime) }}
              </td>
            </tr> -->
          </tbody>
        </table>
        <!-- 显示支付操作 -->
        <div class="row">
          <div class="col-sm-12">
            <div class="alert alert-success" role="alert">
              <div style="font-size: 16px">
                <strong>请选择以下支付方式进行扫码支付，在提示您支付成功之前，请勿关闭当前窗口</strong>
              </div>
              <div style="font-size: 16px">
                <strong><em>（注意：请勿重复支付）</em></strong>
              </div>
            </div>
          </div>
          <div class="col-xs-4 pay-method-box" v-if="payWays.includes('WXPAY')">
            <a href="javascript:void(0)" @click="wxpay" class="pay-method">
              <img :src="wxlogo" alt="微信支付" :style="wxStyle" />
            </a>
          </div>
          <div class="col-xs-4 pay-method-box" v-if="payWays.includes('ALIPAY')">
            <a href="javascript:void(0)" @click="alipay" class="pay-method">
              <img src="@/assets/alipay.png" alt="支付宝支付" style="
                  height: 60px;
                  width: 100%;
                  display: block;
                  margin-top: 80px;
                " />
            </a>
          </div>
          <div class="col-xs-4 pay-method-box" v-if="payWays.includes('FUYI')">
            <a href="javascript:void(0)" @click="fuyipay" class="pay-method-fuyi">
              <img :src="fuyilogo" alt="复翼支付" />
            </a>
          </div>

        </div>
      </div>
      <!-- 隐藏支付宝跳转表单 -->
      <div style="display: none" id="ali_submit_div"></div>
    </div>
    <div class="dialog-footer" slot="footer">
      <el-button @click="cancelTimer" size="mini" type="primary">关 闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { isFlagOn, toQrSrc } from '@/utils/studyFee'

const POLL_INTERVAL = 3000
const POLL_LIMIT = 100

export default {
  name: 'PayDialog',
  data () {
    return {
      payWays: [],
      wxQrCodeLoaded: false, //微信二维码是否加载成功
      wxlogo: "",
      fuyilogo: "",
      isPayed: false, //订单是否支付
      timer: null, //订单支付状态轮询器
      pollCount: 0,
      refreshEmitted: false,
      wxStyle: {
        height: "60px",
        width: "100%",
        display: "block",
        marginTop: "80px",
      },
      dialogVisible: false,
      formData: {},
    };
  },
  watch: {
    isPayed: function (newValue, oldValue) {
      if (newValue) {
        //支付成功，清除定时器
        this.cancelTimer();
      }
    },
  },
  created () {
    this.wxlogo = require("@/assets/wechatpay.png");
    this.fuyilogo = require("@/assets/fuyi.jpg"); // 暂时使用微信支付logo，后续可替换为复翼支付logo
  },
  destroyed () {
    this.clearPoll();
  },
  methods: {
    formatTime (time) {
      // time 格式yyyy-MM-dd hh:mm:ss
      if (!time) {
        return "";
      }
      const timestamp = Date.parse(time);
      const date = new Date(timestamp);
      const YY = date.getFullYear();
      const MM =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      const DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      const h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      const minute =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      const second =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return `${YY}年${MM}月${DD}日 ${h}:${minute}:${second}`;
    },
    createTimer () {
      this.clearPoll();
      this.pollCount = 0;
      this.timer = setInterval(() => {
        this.pollCount += 1;
        if (this.pollCount > POLL_LIMIT) {
          this.clearPoll();
          this.$message.warning('暂未确认到支付结果，请稍后在订单中查看');
          return;
        }
        const orderId = this.formData.orderId;
        if (!orderId) return;
        this.$http.get_s('/student/pc/chooseCourse/isPaid', { orderId }).then((res) => {
          if (isFlagOn(res)) {
            this.onPaid();
          }
        }).catch(() => {});
      }, POLL_INTERVAL);
    },
    clearPoll () {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    onPaid () {
      if (this.isPayed) return;
      this.isPayed = true;
      this.clearPoll();
      this.$message.success('支付成功');
      this.dialogVisible = false;
    },
    cancelTimer () {
      this.clearPoll();
      const hadOrder = !!(this.formData && this.formData.orderId);
      if (hadOrder && !this.refreshEmitted) {
        this.refreshEmitted = true;
        this.$emit('refresh');
      }
      this.dialogVisible = false;
      // 重置状态
      this.payWays = [];
      this.wxQrCodeLoaded = false;
      this.wxlogo = require("@/assets/wechatpay.png");
      this.wxStyle = {
        height: "60px",
        width: "100%",
        display: "block",
        marginTop: "80px",
      };
      this.fuyilogo = require("@/assets/fuyi.jpg");
    },
    open (params) {
      this.formData = params;
      const ways = params?.payways ?? params?.payWays ?? [];
      const parsed = Array.isArray(ways)
        ? ways
        : String(ways)
          .split(',')
          .map(s => s.trim())
          .filter(Boolean);
      this.payWays = parsed.length ? parsed : ['WXPAY', 'ALIPAY'];
      this.dialogVisible = true;
      this.refreshEmitted = false;
      // 重置状态
      this.wxQrCodeLoaded = false;
      this.wxlogo = require("@/assets/wechatpay.png");
      this.wxStyle = {
        height: "60px",
        width: "100%",
        display: "block",
        marginTop: "80px",
      };
      this.isPayed = false;
      this.pollCount = 0;
    },
    payBody (payMethod) {
      return {
        id: this.formData.orderId,
        payMethod,
      };
    },
    wxpay () {
      //发起微信支付
      if (this.wxQrCodeLoaded) {
        return;
      }
      if (!this.timer) {
        this.createTimer();
      }
      this.$http.post('/student/pc/chooseCourse/toPay', this.payBody('WX_PC_PAY')).then((res) => {
        this.wxlogo = toQrSrc(res);
        this.wxQrCodeLoaded = true;
        this.wxStyle = {
          height: "100%",
          width: "100%",
          display: "block",
        };
      });
    },
    async alipay () {
      //发起支付宝支付
      if (!this.timer) {
        this.createTimer();
      }
      this.$http.post('/student/pc/chooseCourse/toPay', this.payBody('ALI_PC_PAY')).then((res) => {
        let aliSubmitDiv = document.getElementById("ali_submit_div");
        aliSubmitDiv.innerHTML = res;
        let formId = "alipcpayform_" + (this.formData.orderNo || '');
        let formedom = document.getElementById(formId);
        if (formedom) {
          formedom.submit();
        } else {
          this.$message.error('支付宝支付页面打开失败');
        }
      })
    },
    fuyipay () {
      // 启动轮询定时器
      if (!this.timer) {
        this.createTimer();
      }
      this.$http.post('/student/pc/chooseCourse/toPay', this.payBody('FUYI')).then((res) => {
        window.open(res, '_blank');
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.pay-method-box {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pay-method {
  height: 220px;
  width: 220px;
  display: block;
  border: 1px solid #ccc;
  padding: 0 12px;
  cursor: pointer;
}

.pay-method-fuyi {
  height: 220px;
  width: 220px;
  display: block;
  box-sizing: border-box;
  border: 1px solid #ccc;
  padding: 10px;
  cursor: pointer;
  img{
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;

  th,
  td {
    padding: 12px;
    border: 1px solid #ddd;
    text-align: left;
  }

  th {
    background-color: #f5f5f5;
    font-weight: 600;
    width: 120px;
  }
}

.alert {
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid transparent;
  border-radius: 4px;

  &.alert-success {
    color: #3c763d;
    background-color: #dff0d8;
    border-color: #d6e9c6;
  }
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;
}

.col-sm-12 {
  width: 100%;
  padding: 0 15px;
}

.col-xs-6 {
  width: 50%;
  padding: 0 15px;
}

.col-xs-4 {
  width: 33.333333%;
  padding: 0 15px;
}
</style>
